export {UploadService} from './upload.service';
export {AuthService} from './auth.service';
export {DBService} from './DB.service';
export {DownLoadService} from './download.service';
export { DashboardService } from './dashboard.service';
